import { EnvConfig } from '../config/EnvConfig'
import { kambiAuthService } from '../services/kambiAuthService'

const KAMBI_OPEN_COUNTS_ENDPOINT = (offering) =>
  `/player/api/v2019/${offering}/coupon/openCounts`

export const getOpenBetsCount = async () => {
  try {
    const offering = EnvConfig.GATSBY_KAMBI_OFFERING
    const response = await kambiAuthService.makeAuthenticatedRequest(
      KAMBI_OPEN_COUNTS_ENDPOINT(offering)
    )
    if (!response.ok) {
      return response
    }

    const openCoupons = response.data?.openCoupons || 0
    return {
      ok: true,
      data: openCoupons,
    }
  } catch (error) {
    return {
      ok: false,
      error: error?.response?.data || error?.message || 'Unknown error',
    }
  }
}
